import { Button, aiBackgroundColor, aiBorderColor, pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledButton = styled(Button) `
  ${aiBorderColor('500')};
  background-color: ${themeGet('colors.primary.0')};
  color: ${themeGet('colors.blue.500')};
  transition-property: border, color, box-shadow, outline, opacity;
  // cannot have animation on background with gradient to avoid glitch

  [data-icon='falcon'] {
    color: ${themeGet('colors.blue.500')};
  }

  &:disabled {
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:hover {
      ${aiBorderColor('500')};
      background-image: none;
      background-color: ${themeGet('colors.background.50')};
    }

    &:active {
      ${aiBackgroundColor('200')};
      ${aiBorderColor('500')};
    }

    &:focus-visible {
      ${aiBackgroundColor('50')}
      box-shadow: 0 0 0 ${pxToRem(4)} ${themeGet('colors.focus.info')};
    }
  }
`;
